import * as React from 'react';

export function SvgGoogle(props: any) {
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.64 12.2044C20.64 11.5663 20.5827 10.9526 20.4764 10.3635H12V13.8449H16.8436C16.635 14.9699 16.0009 15.9231 15.0477 16.5613V18.8194H17.9564C19.6582 17.2526 20.64 14.9453 20.64 12.2044Z"
        fill="#4285F4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 21C14.43 21 16.4673 20.1941 17.9564 18.8195L15.0477 16.5613C14.2418 17.1013 13.2109 17.4204 12 17.4204C9.656 17.4204 7.6718 15.8372 6.964 13.71H3.9574V16.0418C5.4382 18.9831 8.4818 21 12 21Z"
        fill="#34A853"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.964 13.7101C6.784 13.1701 6.6818 12.5932 6.6818 12.0001C6.6818 11.4069 6.7841 10.8301 6.9641 10.2901V7.95819H3.9573C3.32728 9.21237 2.99945 10.5966 3 12.0001C3 13.4523 3.3477 14.8269 3.9573 16.0419L6.9641 13.7101H6.964Z"
        fill="#FBBC05"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 6.5795C13.3214 6.5795 14.5077 7.0336 15.4405 7.9255L18.0218 5.3441C16.4632 3.8918 14.4259 3 12 3C8.48178 3 5.43818 5.0168 3.95728 7.9582L6.96398 10.29C7.67178 8.1627 9.65588 6.5795 12 6.5795Z"
        fill="#EA4335"
      />
    </svg>
  );
}
